import { createContext } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/context/context-key.js';
export const defaultIsExternalLink = (url) => {
    return url.protocol.startsWith('http') && url.origin !== location.origin;
};
export const isExternalLinkContext = createContext('external-link-check');
//# sourceMappingURL=interfaces.js.map